module.exports = __webpack_public_path__ + "static/media/off-boarding.71ec02f8.png";